export function applyOptionUpdate(original, update) {
    if (update === undefined)
        return original;
    if (update === "set_to_none")
        return undefined;
    return update.value;
}
export function mapOptionUpdate(original, mapper) {
    if (original === undefined || original === "set_to_none")
        return original;
    return { value: mapper(original.value) };
}
export function updateFromOptions(original, updated) {
    return original === updated
        ? undefined
        : updated === undefined
            ? "set_to_none"
            : { value: updated };
}
